/**
 * @Description: 初始化主题配置，包含防闪烁脚本注入
 */
export const useThemeInit = () => {
    type Theme = "light" | "dark";
    
    // 获取服务端或客户端的 Cookie
    const colorScheme = useCookie<Theme | null>("color-scheme", { default: () => null });
  
    useHead({
      htmlAttrs: {
        class: "theme-preload",
        // 服务端渲染时如果能确定主题，直接打在 html 标签上
        ...(colorScheme.value === "light" || colorScheme.value === "dark"
          ? { "data-theme": colorScheme.value }
          : {})
      },
      style: [
        {
          tagPosition: "head",
          // 关键：CSS 还没加载时，先用内联样式把首屏背景定住（并匹配系统暗黑）
          innerHTML: `html,body{color-scheme:light dark;forced-color-adjust:none;}
html{background-color:#ffffff;color:#575757;}
@media (prefers-color-scheme: dark){html{background-color:#1a1a1a;color:#eeeeee;}}
html[data-theme="light"]{background-color:#ffffff;color:#575757;}
html[data-theme="dark"]{background-color:#1a1a1a;color:#eeeeee;}
body{background-color:inherit;color:inherit;}`
        } as any
      ],
      script: [
        {
          tagPosition: "head",
          // 关键：首屏渲染前确定 data-theme，且等 load 后再允许 transition
          innerHTML: `(function(){
  try {
    var d = document.documentElement;
    d.classList.add('theme-preload');

    function getCookie(name){
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}\\(\\)\\[\\]\\\\\/\+^]/g, '\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }

    var saved = getCookie('color-scheme');
    if (saved !== 'light' && saved !== 'dark') saved = null;
    var system = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    var theme = saved || system;
    d.setAttribute('data-theme', theme);

    // 同步 theme-color，减少部分移动端地址栏/背景闪动
    var themeColor = theme === 'dark' ? '#1a1a1a' : '#ffffff';
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', themeColor);

    var remove = function(){ d.classList.remove('theme-preload'); };
    if (document.readyState === 'complete') remove();
    else window.addEventListener('load', remove, { once: true });
  } catch (e) {}
})();`
        } as any
      ]
    });
  }
